import * as React from "react";
import { forwardRef } from "react";
const SvgVoltaprocesso = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={18} height={12} fill="none" viewBox="0 0 18 12" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="#623232" d="M6 12 0 6l6-6 1.4 1.4L3.8 5H18v2H3.8l3.6 3.6z" /></svg>;
const ForwardRef = forwardRef(SvgVoltaprocesso);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxOCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgMTJMMCA2TDYgMEw3LjQgMS40TDMuOCA1SDE4VjdIMy44TDcuNCAxMC42TDYgMTJaIiBmaWxsPSIjNjIzMjMyIi8+Cjwvc3ZnPgo=";